export default function registerComponents(module) {
  // <sources-tabs />
  module.component('sourceTabs', {
    controllerAs: 'vm',
    bindings: {
      broadcaster: '=',
      broadcastId: '=',
      location: '=',
    },
    controller: require('./sources-tabs').default,
    template: require('./sources-tabs.html'),
  });
}



// WEBPACK FOOTER //
// ./app/pages/complete-migration/components.js